export const Environment = {
    BASE_API: process.env.REACT_APP_BASE_API,
    FB_CLIENT_ID: process.env.FACEBOOK_APP_ID
}